import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.19 20.27l-2.19 .73v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5","key":"svg-0"}],["path",{"d":"M20 21l2 -2l-2 -2","key":"svg-1"}],["path",{"d":"M17 17l-2 2l2 2","key":"svg-2"}]]

const IconFilterCode = createReactComponent('outline', 'filter-code', 'FilterCode', __iconNode);

export default IconFilterCode;